export default __webpack_public_path__ + "static/media/logo-bottom.be4e95ef.webp";